var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 64 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234 784 c-47 -17 -106 -69 -130 -116 -9 -17 -19 -58 -21 -90 -5 -47 -9 -58 -24 -58 -10 0 -27 -12 -38 -26 -20 -25 -21 -39 -21 -234 0 -195 1 -209 21 -234 l20 -26 279 0 279 0 20 26 c20 25 21 39 21 234 0 195 -1 209 -21 234 -11 14 -28 26 -38 26 -15 0 -19 11 -24 60 -14 161 -169 258 -323 204z m156 -94 c48 -24 70 -64 70 -125 l0 -45 -140 0 -140 0 0 45 c0 60 22 100 68 124 48 26 93 26 142 1z m-15 -375 c16 -15 25 -36 25 -55 0 -70 -86 -105 -135 -55 -50 49 -15 135 55 135 19 0 40 -9 55 -25z",
    fill: "#5F6F7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.308c77728e3ac33b8881ecfb40989acb.svg";
export { ForwardRef as ReactComponent };